import DqCoindistributionpanel from './src/coindistributionpanel'

DqCoindistributionpanel.install = function (Vue) {
  Vue.component(DqCoindistributionpanel.name, DqCoindistributionpanel)
}

export default DqCoindistributionpanel



// WEBPACK FOOTER //
// ./src/dq-ui/packages/coindistributionpanel/coindistributionpanel.js